import { Modal, Calendar, Row, Select, Radio, Col } from 'antd';
import moment from 'moment';
import 'moment/locale/ja';
import { updateDataPayment, updatePaymentDueDate } from 'pages/BillingProcess/slices';
import { createItem, getCreateItem, updateCreateItem } from 'pages/BillingProcess/thunk';
import { FC, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { billingSelectors } from '../../containers/App/selectors';

type Props = {
  visible: boolean;
  eventActive: (visible: boolean) => void;
};

moment.locale('ja');

const ModalCalendar: FC<Props> = ({ visible, eventActive }) => {
  const { dataPayment, paymentDueDate, itemInvoice, loading } = useSelector(billingSelectors);
  const dispatch = useDispatch();
  const [date, setDate] = useState<string>();

  useEffect(() => {
    const invoiceMonth = moment(date).locale('ja');
    const invoiceMonthYear = invoiceMonth.format('YYYY');
    const invoiceMonthMonth = invoiceMonth.format('MM');
    const dataYearMonth: any = `${invoiceMonthYear}${invoiceMonthMonth}`;
    dispatch(getCreateItem(dataYearMonth));
  }, [date, dispatch]);

  useEffect(() => {
    if (paymentDueDate?.payment_due_date) {
      setDate(paymentDueDate.payment_due_date.slice(0, 10));
    } else {
      const month = Number(itemInvoice?.invoice_month?.slice(4) ?? 0);
      if (month !== 0) {
        let monthRequest = 1;
        let year = Number(itemInvoice?.invoice_month?.slice(0, 4)) ?? new Date().getFullYear();
        if (month + 1 > 12) {
          year += 1;
          monthRequest = 1;
        } else {
          monthRequest = month + 1;
        }
        setDate(`${year}-${('0' + monthRequest).slice(-2)}-27`);
      }
    }
  }, [paymentDueDate?.payment_due_date, itemInvoice]);

  const handleSubmit = () => {
    const paymentDueDate = moment(date).startOf('day').format('YYYY-MM-DD[T]HH:mm:ss') + 'Z';
    const invoiceMonth = moment(date);
    const invoiceMonthYear = invoiceMonth.format('YYYY');
    const invoiceMonthMonth = invoiceMonth.format('MM');
    const dataYearMonth: any = `${invoiceMonthYear}${invoiceMonthMonth}`;
    const params: any = {
      items: {
        invoice_month: dataYearMonth,
        payment_due_date: paymentDueDate,
        i_id: dataPayment ? dataPayment?.i_id : '',
      },
      return_item_result: true,
      appId: 'CPAP',
      dataStoreId: 't_paymant_due_date',
    };
    dispatch(updateDataPayment(params.items));
    dispatch(updatePaymentDueDate(params.items));
    if (params.items.invoice_month === dataPayment?.invoice_month) {
      const { invoice_month, ...itemUpdate } = params.items;
      dispatch(updateCreateItem(itemUpdate));
    } else {
      dispatch(createItem(params));
    }
    eventActive(false);
  };

  return (
    <>
      <Modal
        style={{ paddingBottom: 0 }}
        title="支払い期日の登録"
        centered
        closable={false}
        visible={visible}
        onOk={handleSubmit}
        confirmLoading={loading}
        onCancel={() => eventActive(false)}
        okText="保存する"
        cancelText="閉じる"
      >
        <p className="standardBoldFont" style={{ textAlign: 'center' }}>
          各月の支払期日を設定してください。
        </p>
        <Calendar
          value={date ? moment(date) : undefined}
          style={{ width: '300px', margin: '0px auto' }}
          fullscreen={false}
          locale={{
            lang: {
              locale: 'ja',
              placeholder: 'Select date',
              rangePlaceholder: ['Start date', 'End date'],
              today: 'Today',
              now: 'Now',
              backToToday: 'Back to today',
              ok: 'Ok',
              clear: 'Clear',
              month: 'Month',
              year: 'Year',
              timeSelect: 'Select time',
              dateSelect: 'Select date',
              monthSelect: 'Choose a month',
              yearSelect: 'Choose a year',
              decadeSelect: 'Choose a decade',
              yearFormat: 'YYYY',
              dateFormat: 'M/D/YYYY',
              dayFormat: 'D',
              dateTimeFormat: 'M/D/YYYY HH:mm:ss',
              monthFormat: 'MMMM',
              monthBeforeYear: true,
              previousMonth: 'Previous month (PageUp)',
              nextMonth: 'Next month (PageDown)',
              previousYear: 'Last year (Control + left)',
              nextYear: 'Next year (Control + right)',
              previousDecade: 'Last decade',
              nextDecade: 'Next decade',
              previousCentury: 'Last century',
              nextCentury: 'Next century',
            },
            timePickerLocale: {
              placeholder: 'Select time',
            },
            dateFormat: 'YYYY-MM-DD',
            dateTimeFormat: 'YYYY-MM-DD HH:mm:ss',
            weekFormat: 'YYYY-wo',
            monthFormat: 'YYYY-MM',
          }}
          headerRender={({ value, type, onChange, onTypeChange }) => {
            const start = 1;
            const end = 12;
            const monthOptions = [];

            const current = value.clone();
            const localeData = value.localeData();
            const months = [];
            for (let i = 0; i < 12; i++) {
              current.set('month', i);
              months.push(localeData.monthsShort(current));
            }

            for (let index = start; index <= end; index++) {
              monthOptions.push(
                <Select.Option value={months[index - 1]} className="month-item" key={`${index}`}>
                  {months[index - 1]}
                </Select.Option>,
              );
            }
            const month = value.month() + 1;

            const year = value.year();
            const options = [];
            for (let i = year - 10; i < year + 10; i++) {
              options.push(
                <Select.Option key={i} value={i} className="year-item">
                  {i}
                </Select.Option>,
              );
            }
            return (
              <div style={{ padding: 8, float: 'right' }}>
                <Row gutter={8}>
                  <Col>
                    <Select
                      size="small"
                      dropdownMatchSelectWidth={false}
                      className="my-year-select"
                      onChange={(newYear) => {
                        const now = value.clone().year(newYear);
                        onChange(now);
                      }}
                      value={year}
                    >
                      {options}
                    </Select>
                  </Col>
                  <Col>
                    <Select
                      size="small"
                      dropdownMatchSelectWidth={false}
                      value={+month + '月'}
                      onChange={(selectedMonth) => {
                        const newValue = value.clone();
                        newValue.set('month', parseInt(selectedMonth, 10) - 1);
                        onChange(newValue);
                      }}
                    >
                      {monthOptions}
                    </Select>
                  </Col>
                  <Col>
                    <Radio.Group size="small" onChange={(e) => onTypeChange(e.target.value)} value={type}>
                      <Radio.Button value="month">月</Radio.Button>
                      <Radio.Button value="year">年</Radio.Button>
                    </Radio.Group>
                  </Col>
                </Row>
              </div>
            );
          }}
          onChange={(date) => {
            setDate(date.format('YYYY-MM-DDTHH:mm:ssZ'));
          }}
        />
        <p
          style={{
            margin: '0px auto',
            width: 392,
            height: 65,
            backgroundColor: '#ecffb8',
            borderRadius: '100px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          className="standardFont"
        >
          {!loading && date && dataPayment?.payment_due_date && (
            <>
              {moment(date).format('YYYY')}年{moment(date).format('M')}月の支払期日：
              <span className="standardBoldFont">{moment(date).format('YYYY/MM/DD')}</span>
            </>
          )}
        </p>
      </Modal>
    </>
  );
};
export default ModalCalendar;
